
export default (https) => ({
  // The review queue of marketplace SKUs that didn't resolve to a product.
  async unmapped(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');
    const response = await https.get(`/listings/unmapped?${queryString}`);
    return response.data;
  },
  // Existing channel -> product aliases.
  async getList(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');
    const response = await https.get(`/listings?${queryString}`);
    return response.data;
  },
  // Map an unmapped SKU to a product. Backfills open order lines + returns.
  async map(payload) {
    const response = await https.post(`/listings/map`, payload);
    return response.data;
  },
  async ignore(id) {
    const response = await https.post(`/listings/${id}/ignore`);
    return response.data;
  },
  async salesSummary(productId, params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');
    const response = await https.get(`/products/${productId}/sales-summary?${queryString}`);
    return response.data;
  },
});
